// Ops-facing messages for an Ops App action that cannot apply to a schedule change's status. The Ops App
// checks them before sending and ops-support words the server's 409 with them, so both say the same.
// Imported by path (`@plt/asc/src/ops-actions`), so the Ops App bundle does not pull in Restate.

const FINISHED = ['completed', 'awaiting-follow-up-tasks']
const NOT_WITH_OPS_YET = ['started', 'awaiting-booking-id']

// undefined: the override may be sent. A row with no status is sent and left to the server.
export function overrideRefusalMessage(status: string | undefined): string | undefined {
  if (!status || status === 'awaiting-asc-clear') return undefined

  if (status === 'sent-to-manual-handling') {
    return "Use Finalise ASC first: this ASC is still with Ops (sent-to-manual-handling). Override is only for an ASC already finalised and waiting for a ticket reissue that isn't needed."
  }

  if (FINISHED.includes(status)) return `Nothing to override: this ASC is already finished (${status}).`

  if (NOT_WITH_OPS_YET.includes(status)) return `Nothing to override yet: this ASC hasn't reached Ops (${status}).`

  return `Nothing to override: this ASC is closed (${status}).`
}

// undefined: Finalise may be sent. Only statuses where Finalise can never work are refused.
export function finaliseRefusalMessage(status: string | undefined): string | undefined {
  if (status === 'awaiting-asc-clear') {
    return 'Already finalised: this ASC is waiting for the ticket to match (awaiting-asc-clear). Use Override ASC Revalidation only if no reissue is needed.'
  }

  if (status && FINISHED.includes(status)) return `Nothing left to do: this ASC is already finished (${status}).`

  if (status && isClosed(status)) return `Nothing left to do: this ASC is closed (${status}).`

  return undefined
}

function isClosed(status: string): boolean {
  return (
    status === 'not-ticketed' ||
    status === 'no-asc-detected' ||
    status.startsWith('aborted') ||
    status.startsWith('moved-to') ||
    status === 'repeat-of-open-major'
  )
}
